import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getLiveMonitorStats, type GetLiveMonitorStatsParams } from 'services/api/getLiveMonitorStats';
import { queryKeys } from '../queryKeys';

export const useGetLiveMonitorStats = (params: GetLiveMonitorStatsParams, isEnabled = false) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.liveMonitorStats(params),
        queryFn: () => getLiveMonitorStats(params),
        enabled: Boolean(params.id) && isEnabled,
        placeholderData: keepPreviousData,
        refetchInterval: isEnabled ? 10_000 : false,
    });

    return {
        liveMonitorStats: data,
        isLiveMonitorStatsLoading: isLoading,
        isLiveMonitorStatsFetching: isFetching,
        ...rest,
    };
};
